/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum FavoriteActions {
  GET_ALL = '[Favorite] Get All',
  CREATE = '[Favorite] Create',
  DELETE = '[Favorite] Delete',
  SET_LOADING = '[Favorite] Set Loading',
  SET_ERROR = '[Favorite] Set Error',
}
